import { makeAutoObservable } from 'mobx'
import { Category } from 'infra/type'

class CategoryFilterStore {
  selectedCategory: Category | null = null

  constructor() {
    makeAutoObservable(this)
  }

  selectCategory(category: Category | null) {
    this.selectedCategory = category
  }

  clearSelection() {
    this.selectedCategory = null
  }

  get isFiltering(): boolean {
    return this.selectedCategory !== null
  }
}

export const categoryFilterStore = new CategoryFilterStore()
